import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { JitsiComponent } from '@components/jitsi/jitsi.component';
import { ChatService } from '@modules/chat/chat.service';
import { GroupService } from '@modules/chat/group.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-jitsi-incoming-call',
  templateUrl: './jitsi-incoming-call.component.html',
  styleUrls: ['./jitsi-incoming-call.component.scss'],
})
export class JitsiIncomingCallComponent implements OnInit, OnDestroy {
  public avatarUrl!: string;
  public name!: string;
  public room!: string;
  public group?: string | undefined;
  public chat?: string | undefined;

  private subscriptions: Subscription[] = [];

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      avatarUrl: string;
      name: string;
      room: string;
      group?: string;
      chat?: string;
    },
    private dialog: MatDialog,
    private readonly groupService: GroupService,
    private readonly chatService: ChatService
  ) {
    this.avatarUrl = this.data.avatarUrl;
    this.name = this.data.name;
    this.room = this.data.room;
    this.group = this.data?.group;
    this.chat = this.data?.chat;
  }

  async ngOnInit() {}

  public close() {
    this.dialogRef.close();
  }

  public answer() {
    this.dialogRef.close();

    this.dialog.open(JitsiComponent, {
      panelClass: 'custom-dialog-v2',
      hasBackdrop: false,
      data: {
        handleVideoConferenceLeft: (participant, participants) => {
          if (this.group && participant && participants === 0) {
            this.subscriptions.push(
              this.groupService.createStepCallEnded(this.group, participant.roomName).subscribe()
            );
          }

          if (this.chat && participant && participants === 0) {
            this.subscriptions.push(this.chatService.createStepCallEnded(this.chat, participant.roomName).subscribe());
          }
        },
        room: this.room,
      },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
